// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════════════
   PLANO DE PLANTA EN TABLET / MÓVIL
   ───────────────────────────────────────────────────────────────────────────
   El lienzo se maneja con Pointer Events (ver \`FloorPlanMap.jsx\`): un dedo
   desplaza, dos dedos hacen pellizco y el doble toque acerca. Aquí solo queda
   lo que no se puede resolver desde JS:
   · \`touch-action: none\` en el lienzo para que el gesto no scrollee la página;
   · objetivos de dedo más grandes;
   · en pantalla estrecha, el panel lateral pasa a ser una franja inferior.
   ═══════════════════════════════════════════════════════════════════════════ */

.fpm-viewport {
  /* Sin esto, el navegador se queda el arrastre para hacer scroll/zoom y el
     plano no se mueve. */
  touch-action: none;
  overscroll-behavior: contain;
}
.fpm-side {
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

/* ── Objetivos de dedo ───────────────────────────────────────────────────── */
@media (pointer: coarse) {
  .fpm-btn {
    min-height: 40px;
    padding: 6px 12px;
    font-size: 0.82rem;
  }
  .fpm-select {
    min-height: 40px;
    font-size: 16px; /* evita el zoom automático de iOS al enfocar */
  }
  .fpm-side-search {
    min-height: 40px;
    font-size: 16px;
  }
  .fpm-marker {
    width: 34px;
    height: 34px;
    font-size: 0.68rem;
  }
  .fpm-marker-txt {
    max-width: 30px;
  }
  .fpm-pop {
    min-width: 220px;
    font-size: 0.8rem;
  }
  .fpm-pop-go,
  .fpm-pop-del {
    min-height: 32px;
    font-size: 0.8rem;
  }
  .fpm-row {
    min-height: 44px;
    padding: 9px 10px;
  }
  .fpm-row-del {
    min-width: 38px;
    min-height: 38px;
  }
  .fpm-swatch {
    width: 26px;
    height: 26px;
  }
  .fpm-note {
    min-height: 28px;
  }
}

/* ── Pantalla estrecha: la lista va debajo del plano ──────────────────────── */
@media (max-width: 900px) {
  .fpm-toolbar {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    padding: 0.4rem 0.6rem;
  }
  .fpm-toolbar::-webkit-scrollbar {
    display: none;
  }
  .fpm-toolbar > * {
    flex-shrink: 0;
  }
  .fpm-title {
    display: none; /* ocupa media barra y no aporta en una tablet */
  }
  .fpm-select {
    min-width: 170px;
    max-width: 240px;
  }
  .fpm-hint {
    display: none;
  }
  .fpm-sep {
    display: none;
  }

  .fpm-body {
    flex-direction: column;
  }
  .fpm-viewport {
    order: 1;
    min-height: 200px;
  }
  .fpm-side {
    order: 2;
    width: 100%;
    flex: 0 0 auto;
    max-height: 38dvh;
    border-right: 0;
    border-top: 1px solid var(--border);
    padding: 0.5rem 0.6rem 0.75rem;
  }
  .fpm-body.is-side-collapsed .fpm-side {
    display: none;
  }
}

/* En vertical y con dedo, el globo del marcador no puede salirse por arriba. */
@media (max-width: 560px) {
  .fpm-pop {
    bottom: auto;
    top: 118%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FloorPlanMapTouch.css"],"names":[],"mappings":"AAAA;;;;;;;;;gFASgF;;AAEhF;EACE;yBACuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,+EAA+E;AAC/E;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,eAAe,EAAE,+CAA+C;EAClE;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa,EAAE,gDAAgD;EACjE;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,QAAQ;IACR,iBAAiB;EACnB;EACA;IACE,QAAQ;IACR,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,mCAAmC;IACnC,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;AACF;;AAEA,+EAA+E;AAC/E;EACE;IACE,YAAY;IACZ,SAAS;EACX;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════════════\r\n   PLANO DE PLANTA EN TABLET / MÓVIL\r\n   ───────────────────────────────────────────────────────────────────────────\r\n   El lienzo se maneja con Pointer Events (ver `FloorPlanMap.jsx`): un dedo\r\n   desplaza, dos dedos hacen pellizco y el doble toque acerca. Aquí solo queda\r\n   lo que no se puede resolver desde JS:\r\n   · `touch-action: none` en el lienzo para que el gesto no scrollee la página;\r\n   · objetivos de dedo más grandes;\r\n   · en pantalla estrecha, el panel lateral pasa a ser una franja inferior.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n\r\n.fpm-viewport {\r\n  /* Sin esto, el navegador se queda el arrastre para hacer scroll/zoom y el\r\n     plano no se mueve. */\r\n  touch-action: none;\r\n  overscroll-behavior: contain;\r\n}\r\n.fpm-side {\r\n  -webkit-overflow-scrolling: touch;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n/* ── Objetivos de dedo ───────────────────────────────────────────────────── */\r\n@media (pointer: coarse) {\r\n  .fpm-btn {\r\n    min-height: 40px;\r\n    padding: 6px 12px;\r\n    font-size: 0.82rem;\r\n  }\r\n  .fpm-select {\r\n    min-height: 40px;\r\n    font-size: 16px; /* evita el zoom automático de iOS al enfocar */\r\n  }\r\n  .fpm-side-search {\r\n    min-height: 40px;\r\n    font-size: 16px;\r\n  }\r\n  .fpm-marker {\r\n    width: 34px;\r\n    height: 34px;\r\n    font-size: 0.68rem;\r\n  }\r\n  .fpm-marker-txt {\r\n    max-width: 30px;\r\n  }\r\n  .fpm-pop {\r\n    min-width: 220px;\r\n    font-size: 0.8rem;\r\n  }\r\n  .fpm-pop-go,\r\n  .fpm-pop-del {\r\n    min-height: 32px;\r\n    font-size: 0.8rem;\r\n  }\r\n  .fpm-row {\r\n    min-height: 44px;\r\n    padding: 9px 10px;\r\n  }\r\n  .fpm-row-del {\r\n    min-width: 38px;\r\n    min-height: 38px;\r\n  }\r\n  .fpm-swatch {\r\n    width: 26px;\r\n    height: 26px;\r\n  }\r\n  .fpm-note {\r\n    min-height: 28px;\r\n  }\r\n}\r\n\r\n/* ── Pantalla estrecha: la lista va debajo del plano ──────────────────────── */\r\n@media (max-width: 900px) {\r\n  .fpm-toolbar {\r\n    flex-wrap: nowrap;\r\n    overflow-x: auto;\r\n    scrollbar-width: none;\r\n    padding: 0.4rem 0.6rem;\r\n  }\r\n  .fpm-toolbar::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n  .fpm-toolbar > * {\r\n    flex-shrink: 0;\r\n  }\r\n  .fpm-title {\r\n    display: none; /* ocupa media barra y no aporta en una tablet */\r\n  }\r\n  .fpm-select {\r\n    min-width: 170px;\r\n    max-width: 240px;\r\n  }\r\n  .fpm-hint {\r\n    display: none;\r\n  }\r\n  .fpm-sep {\r\n    display: none;\r\n  }\r\n\r\n  .fpm-body {\r\n    flex-direction: column;\r\n  }\r\n  .fpm-viewport {\r\n    order: 1;\r\n    min-height: 200px;\r\n  }\r\n  .fpm-side {\r\n    order: 2;\r\n    width: 100%;\r\n    flex: 0 0 auto;\r\n    max-height: 38dvh;\r\n    border-right: 0;\r\n    border-top: 1px solid var(--border);\r\n    padding: 0.5rem 0.6rem 0.75rem;\r\n  }\r\n  .fpm-body.is-side-collapsed .fpm-side {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* En vertical y con dedo, el globo del marcador no puede salirse por arriba. */\r\n@media (max-width: 560px) {\r\n  .fpm-pop {\r\n    bottom: auto;\r\n    top: 118%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
